import i18n from '@/i18n';

import { savePrivateInfo, getPrivateInfo } from '@/services/network/privateInfo';
import { transformPrivateInfo } from '@/services/privateInfo/transformers';
import { SESSION_FINISHED } from '@/store/session/actionTypes';
import { SHOW_NOTIFICATION } from '@/store/notification/actionTypes';
import { SAVE_PRIVATE_INFO, GET_PRIVATE_INFO, UPDATE_PRIVATE_INFO } from './actionTypes';
import {
  SET_SAVING_PRIVATE_INFO_STATUS,
  SET_PRIVATE_INFO,
  STASH_PRIVATE_INFO_CHANGES,
  CLEAR_PRIVATE_INFO,
  SET_LOADING,
} from './mutationTypes';

export default {
  async [GET_PRIVATE_INFO]({ commit }) {
    commit(SET_LOADING, true);
    try {
      const info = await getPrivateInfo();
      commit(SET_PRIVATE_INFO, info);
    } finally {
      commit(SET_LOADING, false);
    }
  },
  async [UPDATE_PRIVATE_INFO]({ commit }, updates) {
    commit(STASH_PRIVATE_INFO_CHANGES, updates);
  },
  async [SAVE_PRIVATE_INFO]({ dispatch, commit }, data = {}) {
    commit(SET_SAVING_PRIVATE_INFO_STATUS, true);

    const dataToSave = { ...data };
    const changes = transformPrivateInfo(dataToSave);

    try {
      await savePrivateInfo(changes);
      commit(STASH_PRIVATE_INFO_CHANGES, dataToSave);
    } catch (e) {
      dispatch(SHOW_NOTIFICATION, {
        type: 'error',
        message: i18n.t('update.error'),
      });
      throw new Error('Not saved');
    } finally {
      commit(SET_SAVING_PRIVATE_INFO_STATUS, false);
    }
  },
  [SESSION_FINISHED]({ commit }) {
    commit(CLEAR_PRIVATE_INFO);
  },
};
